import template from './sw-desktop.html.twig';

Shopware.Component.override('sw-desktop', {
    template,
});
